import React from 'react'
import Button from 'gu-ui-kit/Button'
import Grid from 'gu-ui-kit/Grid/Container'
import Icon from 'gu-ui-kit/Icon'
import Typography from 'gu-ui-kit/Typography'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectAppUser } from 'modules/App/store/selectors'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { createBillingTopUpLink } from 'utils/createBillingTopUpLink'
import { ROUTES } from 'constants/routes'
import { useTranslation } from 'react-i18next'
import styles from './balance-widget.module.scss'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { formatToString } from 'utils/formatMoney'

const BalanceWidget = ({ className, collapse, minimalistic = false, small = false }) => {
  const { balance } = useSelector(selectAppUser)
  const pathGen = useGeneratePathI18n()
  const location = useLocation()
  const { t } = useTranslation(['common'])

  const topUpLink = createBillingTopUpLink(pathGen(ROUTES.BILLING_TOP_UP), location)

  return (
    <Grid
      className={clsx(className, styles['balance-widget'], {
        [styles['balance-widget__add-funds-button_collapse-container']]: collapse,
        [styles['balance-widget_minimalistic']]: minimalistic,
      })}
    >
      {collapse ? (
        <Button
          noLabel
          noWrap
          className={styles['balance-widget__add-funds-button']}
          component={Link}
          size={'m'}
          startIcon={<Icon name={'plus'} />}
          title={t('common::user_menu.add_funds')}
          to={topUpLink}
          variant={'primary'}
        />
      ) : (
        <Grid
          direction={'row'}
          gap={16}
          justifyContent={'space-between'}
          wrap={false}
        >
          <Grid
            direction={'column'}
            justifyContent={'center'}
          >
            <Typography
              className={styles['balance-widget__label']}
              color={'Label-Secondary'}
              variant={small ? 'Body-5' : 'Body-10'}
            >
              {t('common::header.balance')}
            </Typography>
            <Typography
              className={'balance-value'}
              color={'Label-Fifth'}
              component={
                <Link to={pathGen(ROUTES.FINANCE_WALLETS)}>
                  {balance && formatToString(balance.amount, balance.currency)}
                </Link>
              }
              variant={small ? 'Body-15' : 'Body-25'}
            />
          </Grid>
          <Grid
            flexDirection={'column'}
            fluid={false}
            justifyContent={'center'}
          >
            <Button
              noLabel
              noWrap
              className={styles['balance-widget__add-funds-button']}
              component={Link}
              size={small ? 's' : 'm'}
              startIcon={
                <Icon
                  name={'plus'}
                  size={'sm'}
                />
              }
              title={t('common::user_menu.add_funds')}
              to={topUpLink}
              variant={'primary'}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default BalanceWidget

BalanceWidget.propTypes = {
  small: PropTypes.bool,
  minimalistic: PropTypes.bool,
  className: PropTypes.string,
  collapse: PropTypes.bool,
}
